export enum EmployeeStatusTabsModel {
  Accepted = 0,
  Open = 1,
  Declined = 2,
  Requested = 3,
  Queue = 4,
  ByChannel = 5,
  Completed = 6,
  NoShows = 7,
}
